import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * Wraps protected route groups. While the auth bootstrap is running we
 * show a quiet editorial loader (no flash of unauthenticated content);
 * if the user is anonymous we redirect to /login and remember the
 * intended destination via location state.
 */
const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div data-testid="protected-route-loading" className="flex min-h-[60vh] items-center justify-center">
        <div className="text-center">
          <div className="label-overline text-neutral-500">Verifying session…</div>
          <div className="mt-3 h-px w-24 mx-auto bg-neutral-300 animate-pulse" />
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }

  return children ? children : <Outlet />;
};

export default ProtectedRoute;
